'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _MPPHeading = require('../../atoms/heading/jsx/MPPHeading');

var _MPPHeading2 = _interopRequireDefault(_MPPHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var DSHero = function (_React$Component) {
  _inherits(DSHero, _React$Component);

  function DSHero() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DSHero);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DSHero.__proto__ || Object.getPrototypeOf(DSHero)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _MPPHeading2.default,
          { level: '1', className: 'ds-hero__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderParagraph = function (paragraph) {
      if (paragraph) {
        return _react2.default.createElement(
          'p',
          { className: 'ds-hero__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    }, _this.renderHatchText = function (hatchText) {
      if (hatchText && hatchText.text) {
        return _react2.default.createElement(
          'p',
          { className: 'ds-hero__hatch-text' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DSHero, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          hatchText = content.hatchText;

      var classes = (0, _classnames2.default)('ds-hero', config.theme, className);

      return _react2.default.createElement(
        'section',
        { id: config.id, className: classes, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-sm-8' },
              this.renderHeadline(headline),
              this.renderParagraph(paragraph),
              this.renderHatchText(hatchText)
            )
          )
        )
      );
    }
  }]);

  return DSHero;
}(_react2.default.Component);

exports.default = DSHero;


DSHero.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

DSHero.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-light'
  },
  content: {
    headline: {
      text: '34 characters maximum'
    },
    paragraph: {
      text: '90 characters maximum equal to 4 lines or less on mobile devices is preferred.'
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/ds-hero/DSHero.js
// module id = 1083
// module chunks = 4